/**
 *
 * @param {HTMLSelectElement} select
 */
export function hideSelectError(select) {
  select.classList.remove('error')
  const sibling = select.nextElementSibling
  if (sibling && sibling.classList.contains('select-error-container')) {
    sibling.innerHTML = ''
  }
}

/**
 * Must have structure below:

  <div class="input-container">
    <input
      data-error-message="Please Enter Your Full Name"
      data-test="name"
      id="name"
      name="name"
      placeholder="Full Name"
      required
      type="text"
    />
    <div class="input-error-container"></div>
  </div>

 */
